export const CREATOR_BOTTOM_TABS = [
  {
    name: 'Home',
    route: 'CreatorDashboardMobile',
    icon: 'IconHome',
    exact: false
  },
  {
    name: 'Messages',
    route: 'CreatorMessageDashboard',
    icon: 'IconMessages',
    exact: false,
    activeRoutes: ['CreatorMessageDashboard', 'CreatorDirectMessage', 'Announcement']
  },
  {
    name: 'Requests',
    route: 'CustomRequestList',
    icon: 'IconRequests',
    exact: false,
    activeRoutes: ['CustomRequestList', 'CustomRequestOptionList', 'CustomRequestOptionCreate']
  },
  {
    name: 'Content',
    route: 'BonusContentList',
    icon: 'IconContent',
    exact: false,
    activeRoutes: ['BonusContentList', 'BonusContentAdd', 'BonusContentEdit']
  },
  {
    name: 'More',
    action: 'more',
    icon: 'IconProfile',
    exact: false
  }
];

export const CREATOR_MORE_ITEMS = [
  {
    name: 'Manage Fans',
    route: 'CreatorDashboardMobile',
    params: { tab: 'active' },
    icon: 'IconProfile'
  },
  {
    name: 'Custom Request Options',
    route: 'CustomRequestOptionList',
    icon: 'IconRequests'
  },
  {
    name: 'Recent Transactions',
    route: 'RecentTransactionMobile',
    icon: 'IconTransactions'
  },
  {
    name: 'Billing & Payouts',
    route: 'BillingMobile',
    icon: 'IconBilling'
  },
  {
    name: 'Blocked Fans',
    route: 'BlockedFriendsMobile',
    icon: 'IconProfile'
  },
  {
    name: 'Account Settings',
    route: 'SettingsMobile',
    icon: 'IconSettings'
  },
  {
    name: 'Help & Support',
    route: 'HelpMobile',
    icon: 'IconHelp'
  }
];

export const FAN_BOTTOM_TABS = [
  {
    name: 'Home',
    route: 'CustomerDashboardMobile',
    icon: 'IconHome',
    exact: false
  },
  {
    name: 'Messages',
    route: 'CustomerMessageDashboard',
    icon: 'IconMessages',
    exact: false,
    activeRoutes: ['CustomerMessageDashboard', 'CustomerDirectMessage', 'MessageCta']
  },
  {
    name: 'Requests',
    route: 'CustomerCustomRequestList',
    icon: 'IconRequests',
    exact: false,
    activeRoutes: ['CustomerCustomRequestList', 'CustomerCustomRequestList1']
  },
  {
    name: 'Bonus',
    route: 'CustomerBonusContentList',
    icon: 'IconContent',
    exact: false,
    activeRoutes: ['CustomerBonusContentList']
  },
  {
    name: 'More',
    action: 'more',
    icon: 'IconProfile',
    exact: false
  }
];

export const FAN_MORE_ITEMS = [
  {
    name: 'Recent Transactions',
    route: 'CustomerRecentTransaction',
    icon: 'IconTransactions'
  },
  {
    name: 'Payment Options',
    route: 'PaymentOption',
    icon: 'IconBilling'
  },
  {
    name: 'Account Settings',
    route: 'CustomerSettings',
    icon: 'IconSettings'
  },
  {
    name: 'Help & Support',
    route: 'HelpMobile',
    icon: 'IconHelp'
  }
];
